<template>
  <q-page padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold">
        Listagem de Funções / Processos
      </p>
    </div>

    <div
      class="row col-12 q-mt-md q-gutter-sm text-brand-5 text-weight-bold items-center"
    >
      <div class="col-2">
        <div>Nome</div>
        <q-input dense outlined v-model="nome" label="Nome" />
      </div>

      <div class="col-2">
        <div>Unidade</div>
        <lista-unidades-select v-model="unidade"></lista-unidades-select>
      </div>
      <div class="col-2">
        <div>Linhas Por Pagina</div>
        <q-select v-model="perPage" :options="perPageOption" dense outlined>
        </q-select>
      </div>
      <div>
        <p></p>
        <q-btn
          no-caps
          color="positive"
          label="Criar Novo"
          icon="add"
          class="q-mt-xs"
          @click="criar"
        />
      </div>
      <div v-if="filtrosAtivos">
        <p></p>
        <q-btn
          no-caps
          color="negative"
          label="Limpar Filtros"
          icon="refresh"
          class="q-mt-xs"
          @click="limparFiltros()"
        />
      </div>
    </div>

    <table-GHE :perPage="perPage" :atualizar="atualizar" />
  </q-page>
</template>

<script>
import { useQuasar } from "quasar";
import { ref, onMounted, onActivated, watch } from "vue";
import { useStore } from "vuex";
import { useFilterPersistence } from "../../../../composables/useFilterPersistence";

import TableGHE from "../components/TableGHE.vue";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";

export default {
  components: { TableGHE, ListaUnidadesSelect },
  setup() {
    const $q = useQuasar();
    const unidade = ref();
    const store = useStore();
    const nome = ref("");
    const perPage = ref("15");
    const atualizar = ref(0);

    const STORAGE_KEY = "processos-funcoes-filtros";

    const {
      salvarFiltros,
      carregarFiltros: carregarFiltrosComposable,
      limparFiltros: limparFiltrosComposable,
      filtrosAtivos: filtrosAtivosComposable,
    } = useFilterPersistence(
      STORAGE_KEY,
      { unidade, nome, perPage },
      {
        unidade: { nome: "", id: "", logo: "", codigoUnidadeIntegracao: "" },
        nome: "",
        perPage: "15",
      }
    );

    const filtrosAtivos = filtrosAtivosComposable;

    const carregarFiltros = () => {
      carregarFiltrosComposable();
    };

    const limparFiltros = ({ recarregar = true } = {}) => {
      limparFiltrosComposable();
      localStorage.removeItem("unidade");
      unidade.value = {
        nome: "",
        id: "",
        logo: "",
        codigoUnidadeIntegracao: "",
      };
      if (recarregar) atualizar.value++;
    };

    const criar = async () => {
      if (nome.value == "") {
        $q.notify({
          message: "O campo nome é obrigatório.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        await store.dispatch("processos/criarFuncao", {
          vendor_id: store.state.org.unidadeData.id,
          funcao: nome.value,
        });

        $q.notify({
          message: "Função criada com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        atualizar.value++;
        resetarVariaveis();
      } catch (error) {
        $q.notify({
          message: "Erro ao criar função.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const resetarVariaveis = () => {
      nome.value = "";
    };

    onMounted(() => {
      carregarFiltros();
    });

    onActivated(() => {
      carregarFiltros();
    });

    watch(
      () => nome.value,
      () => {
        salvarFiltros();
      }
    );

    watch(
      () => unidade.value,
      () => {
        salvarFiltros();
      }
    );

    watch(
      () => perPage.value,
      () => {
        salvarFiltros();
      }
    );

    return {
      criar,
      atualizar,
      nome,
      resetarVariaveis,
      unidade,
      perPageOption: ["10", "30", "50", "100", "200"],
      perPage,
      filtrosAtivos,
      limparFiltros,
    };
  },
};
</script>

<style></style>
